import { render, staticRenderFns } from "./PicturePdfModal.vue?vue&type=template&id=2c6a54de&lang=pug"
import script from "./PicturePdfModal.vue?vue&type=script&lang=ts"
export * from "./PicturePdfModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports